<!-- Search Input -->
<div class="mr-4">
  <div class="search-section">
    <div class="search-input-wrapper mt-0.5">
      <input
        pInputText
        type="text"
        [value]="searchText()"
        (input)="onSearchChange($event)"
        [placeholder]="'goods.classify.sidebar.search_placeholder' | translate"
        class="search-input"
        [class.has-text]="searchText()"
      />
      @if (searchText()) {
        <button
          type="button"
          class="clear-button"
          (click)="clearSearch()"
          [pTooltip]="'goods.classify.sidebar.clear_search' | translate"
          tooltipPosition="bottom"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      }
    </div>
  </div>

  <!-- All Categories Header -->
  <div class="all-categories-wrapper">
    <app-button
      [label]="'goods.classify.sidebar.clear_categories' | translate"
      severity="secondary"
      [outlined]="true"
      (emitOnClick)="onAllCategoriesClick()"
    ></app-button>
  </div>

  <!-- Tree Container -->
  <div class="tree-container" #treeContainer>
    @if (loading()) {
      <div class="loading-container">
        <div class="custom-spinner"></div>
        <span class="loading-text">{{
          "goods.classify.management.loading" | translate
        }}</span>
      </div>
    } @else {
      <p-tree
        [value]="filteredTreeData()"
        [selectionMode]="'single'"
        [selection]="selectedNode()"
        [draggableNodes]="true"
        [droppableNodes]="true"
        [validateDrop]="true"
        (onNodeSelect)="onNodeSelect($event.node)"
        (onNodeDrop)="onCategoryDrop($event)"
        class="category-tree"
      >
        <ng-template pTemplate="default" let-node>
          <div class="tree-node-content" [attr.data-type]="node.data?.type">
            <span class="node-label" [title]="node.label">
              {{ node.label }}
            </span>
          </div>
        </ng-template>
      </p-tree>
    }
  </div>
</div>
